import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=c9fd07ac&scoped=true"
import script from "./Config.vue?vue&type=script&lang=ts"
export * from "./Config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fd07ac",
  null
  
)

export default component.exports